import {createSlice, createSelector} from '@reduxjs/toolkit';
import {FormSliderInit} from "./model";


// import {INIT} from './../constants/status';

const initialState = {
    sliders: [],
    sliderForm: FormSliderInit,
};

const sliderSlice = createSlice({
    name: 'slider',
    initialState,
    reducers: {
        setSliders: (state, action) => {
            state.sliders = action.payload;
        },
        onSliderFormChange: (state, action) => {
            const {name, value} = action.payload;
            state.sliderForm[name] = value;
        },
        initSliderForm: (state, action) => {
            state.sliderForm = action.payload;
        },
    },
});

export const {actions} = sliderSlice;
export const {
    setSliders,
    onSliderFormChange,
    initSliderForm,
} = actions;

// selectors

export const selSliders = (state) => state.slider.sliders;
export const selSliderForm = (state) => state.slider.sliderForm;

const reducer = {
    slider: sliderSlice.reducer,
};
export default reducer;